import type { ComponentProps } from 'react';

import {
	FASTSHIFT_DC_CONNECTION_STATUSES,
	type FastshiftDcConnectionStatus,
} from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import type Lozenge from '@atlaskit/lozenge';

import { messages } from './messages';

import type { MessageDescriptor } from 'react-intl';

type LozengeAppearance = NonNullable<ComponentProps<typeof Lozenge>['appearance']>;

const CONNECTION_STATUS_CONFIG: Record<
	FastshiftDcConnectionStatus,
	{ appearance: LozengeAppearance; message: MessageDescriptor }
> = {
	[FASTSHIFT_DC_CONNECTION_STATUSES.CONNECTED]: {
		appearance: 'success',
		message: messages.connectionConnected,
	},
	[FASTSHIFT_DC_CONNECTION_STATUSES.INITIALIZED]: {
		appearance: 'information',
		message: messages.connectionInitialized,
	},
	[FASTSHIFT_DC_CONNECTION_STATUSES.REGENERATING]: {
		appearance: 'information',
		message: messages.connectionRegenerating,
	},
	[FASTSHIFT_DC_CONNECTION_STATUSES.DISABLED]: {
		appearance: 'neutral',
		message: messages.connectionDisconnected,
	},
	[FASTSHIFT_DC_CONNECTION_STATUSES.EXPIRED]: {
		appearance: 'warning',
		message: messages.connectionExpired,
	},
	[FASTSHIFT_DC_CONNECTION_STATUSES.INTERRUPTED]: {
		appearance: 'danger',
		message: messages.connectionInterrupted,
	},
	[FASTSHIFT_DC_CONNECTION_STATUSES.FAILED]: {
		appearance: 'danger',
		message: messages.connectionFailed,
	},
	[FASTSHIFT_DC_CONNECTION_STATUSES.OFFLINE]: {
		appearance: 'neutral',
		message: messages.connectionOffline,
	},
};

const UNKNOWN_CONNECTION_STATUS_CONFIG: {
	appearance: LozengeAppearance;
	message: MessageDescriptor;
} = {
	appearance: 'neutral',
	message: messages.connectionUnknown,
};

export const getConnectionStatusConfig = (status: string) =>
	CONNECTION_STATUS_CONFIG[status as FastshiftDcConnectionStatus] ??
	UNKNOWN_CONNECTION_STATUS_CONFIG;
